import React from 'react';
import {useLocation, useNavigate, useSearchParams} from 'react-router-dom';
import './ClientError.css';
import {getDriverRouteById} from "../../components/routes/driverRoutes";
import {Button, Result, Row, Typography} from "antd";
import {useTranslation} from "react-i18next";
import {MainImage} from "../../components/image/MainImage";
import {themeLocations} from "../../theme/themeLocations";
import { decode } from "base-64";

const { Title, Text } = Typography;

/*
 Shows error or not found message
*/
const ClientError = ({notFound = false, sso = false, error, resetErrorBoundary}) => {

    const location = useLocation();
    let sourceLocation = location.state ? location.state.sourceLocation : undefined;

    const [searchParams] = useSearchParams();

    const { t } = useTranslation();

    if (error) {
        console.error('Error from ErrorBoundary:');
        console.error(error);
        console.error('Source: ' + sourceLocation);
        //console.log(process.env);
    }

    const navigate = useNavigate();

    const onHomeClick = () => {
        if (error && resetErrorBoundary) {
            resetErrorBoundary();
        } else {
            navigate(getDriverRouteById('home'), {replace: true});
        }
    }

    // No user for SSO
    const externalIdParam = searchParams ? searchParams.get("external_id") : null;
    const externalId = externalIdParam ? decode(externalIdParam) : null;

    // Messages
    let errorTitle = '';
    let errorText = '';
    if (sso && notFound && externalId) {
        errorTitle = t('title.sso_login_no_user');
        errorText = t('message.user_profile_not_found', {0: externalId});
    }
    else if (sso) {
        errorTitle = notFound ? t('title.sso_login_no_user'): t('title.sso_login_error');
        errorText = t('message.retry_and_contact');
    }
    else {
        errorTitle = notFound ? t('title.not_found') : t('title.system_error');
        errorText = t('message.retry_and_contact');
    }

    // PAGE
    return (
            <div className="client-error-wrapper">
                <Row type="flex" justify="center" className="error-logo">
                    <MainImage imageSrc={themeLocations.MAIN_LOGO}/>
                </Row>
                <Result status={notFound ? 404 : 500} />
                <Row className="client-error-text" justify="center" align="middle">
                    <Title level={1}>{errorTitle}</Title>
                </Row>
                <Row className="client-error-text" justify="center" align="middle">
                    <Text>{errorText}</Text>
                </Row>
                <Row className="client-error-text" justify="center" align="middle">
                    {sso
                     ? <></>
                     : <Button className="client-error-button" onClick={() => onHomeClick()}>{t('action.return_home')}</Button>
                    }
                </Row>
            </div>
    );
}

export default ClientError;